var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          staticStyle: { "margin-left": "1% !important" },
          attrs: { justify: "center" },
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "overflow-visible",
              staticStyle: { height: "56px" },
            },
            [
              _c(
                "v-bottom-navigation",
                {
                  attrs: {
                    elevation: 24,
                    color: "rgb(204 33 40)",
                    grow: "",
                    width: "98% !important",
                  },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { value: "usuarios" } },
                    [
                      _c("v-icon", [_vm._v("mdi-account-group")]),
                      _vm._v(" Usuarios "),
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    { attrs: { value: "roles" } },
                    [
                      _c("v-icon", [_vm._v("mdi-account-key")]),
                      _vm._v(" Roles "),
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    { attrs: { value: "permisos" } },
                    [
                      _c("v-icon", [_vm._v("mdi-shield-check")]),
                      _vm._v(" Permisos "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "base-card",
        [
          _c("v-card-text", { staticClass: "mt-3" }, [
            _c(
              "div",
              { staticClass: "py-6" },
              [_c(_vm.currentComponent, { tag: "component" })],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }